import { styled, Typography, Box, Button } from '@mui/material';

import { theme } from 'styles';

export const ModalHeader = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 0;
`;

export const ModalTitle = styled(Typography)`
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;

  @media (max-width: 1023px) {
    display: none;
  }
`;

export const SearchWrapper = styled(Box)`
  padding: 16px 24px;
`;

export const FileGrid = styled(Box)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  padding: 0px;
  min-height: 200px;

  @media (max-width: 1023px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const FileCardWrapper = styled(Box)<{ selected: boolean }>`
  border: 2px solid ${({ selected, theme }) => (selected ? theme.palette.info.main : '#e0e0e0')};
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;
  position: relative;
  background: #fff;
  transition: border-color 0.15s;

  &:hover {
    border-color: ${({ theme }) => theme.palette.info.main};
  }
`;

export const CardCheckboxWrapper = styled(Box)`
  position: absolute;
  top: 8px;
  left: 8px;
`;

export const CardIconWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 0;
`;

export const CardTitle = styled(Typography)`
  font-size: 14px;
  font-weight: 700;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
`;

export const CardMeta = styled(Typography)`
  font-size: 14px;
  color: #666;
  margin-top: 2px;
`;

export const EmptyStateWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  width: 100%;
  grid-column: 1 / -1;
`;

export const StyledImage = styled('img')`
  width: 200px;
  height: 100px;
  object-fit: contain;
`;

export const IconBox = styled('div')`
  width: 44px;
  height: 44px;
  min-width: 44px;
  min-height: 44px;

  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  background: ${theme.palette.info.light};

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const AddButton = styled(Button)`
  width: 120px;
  text-transform: none;
  border-radius: 8px;
  padding: 10px 24px;
  font-weight: 600;
  font-size: 16px;
  background: ${({ theme }) => theme.palette.info.main};
  color: ${({ theme }) => theme.palette.white.main};

  &:hover {
    background: ${({ theme }) => theme.palette.info.dark};
  }

  &:disabled {
    background: ${({ theme }) => theme.palette.info.p030};
    color: ${({ theme }) => theme.palette.white.main};
  }
`;

export const CancelBtn = styled(Button)`
  text-transform: none;
  border-radius: 8px;
  padding: 10px 32px;
  font-weight: 600;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.primary.p080};
  border-color: ${({ theme }) => theme.palette.primary.light};
  background: ${({ theme }) => theme.palette.white.main};

  &:hover {
    background: ${({ theme }) => theme.palette.white.p100};
    border-color: ${({ theme }) => theme.palette.primary.p030};
  }
`;

export const VideoW = styled('div')`
  height: 100px;
  width: 200px;
  position: relative;
`;

export const PlayButtonContainer = styled('div')`
  position: absolute;
  top: 50%;
  left: 50%;
  max-height: 100px;
  max-width: 200px;
  transform: translate(-50%, -50%);
`;

export const StyledVideo = styled('img')`
  width: 100%;
  height: 100%;
  object-fit: contain;
  max-height: 100px;
  max-width: 200px;
`;
